import { PageType, UrlState } from "@multimediallc/cb-roomlist-prefetch"
import { addPageAction } from "../../../../common/newrelic"
import { i18n } from "../../../../common/translation"
import { dom } from "../../../../common/tsxrender/dom"
import { SuggestionClicked } from "../baseSuggestedItem"
import { ResultType } from "../constants"
import { historyDeleteClicked } from "../historySuggestedItem"
import { deleteFromSearchHistory, saveSearchHistory } from "../searchHistory"
import { MobileSearchPaneSuggestedItem, MobileSearchSuggestionClicked } from "./mobileSearchPaneSuggestedItem"
import type { ISuggestionProps } from "../baseSuggestedItem"


export class MobileSearchPaneHistorySuggestedItem extends MobileSearchPaneSuggestedItem {
    protected getIconClassName(): string {
        return "icon-history"
    }

    protected getStatusText(): string {
        return i18n.previouslySearched
    }

    protected getRowClassName(): string {
        return "historySuggestion"
    }

    protected onClickHandler(props: ISuggestionProps, event?: MouseEvent): void {
        const attributes = { "resultType": "history", "resultString": props.labelText }
        addPageAction("SearchBarResultsClick", attributes)
        if (props.href.includes("/tag/")) {
            saveSearchHistory(props.labelText, ResultType.Hashtag)
            if (event !== undefined) {
                // SPA handling only needed on roomlist pages, otherwise default behavior is as desired
                if (UrlState.current.state.pageType === PageType.HOME) {
                    event.preventDefault()
                    UrlState.current.navigateTo(props.href)
                }
            }
        } else if (props.href !== "") {
            saveSearchHistory(props.labelText, ResultType.Online)
        } else {
            SuggestionClicked.fire(props.labelText)
        }
        MobileSearchSuggestionClicked.fire()
    }

    protected createElement(props: ISuggestionProps): HTMLAnchorElement {
        const main = super.createElement(props)
        const historyDelete = <div
            className="historyDelete"
            onClick={(e: MouseEvent) => {
                e.preventDefault()
                e.stopPropagation()
            }}
            onMouseDown={(evt: MouseEvent) => {
                if (evt.ctrlKey || evt.metaKey || evt.button === 2) {
                    return
                }
                deleteFromSearchHistory(props.labelText)
                historyDeleteClicked.fire(props.labelText)
                evt.preventDefault()
                evt.stopPropagation()
            }}>
        </div>
        const row = main.firstElementChild
        if (row !== null) {
            const labelContainer = row.lastElementChild
            if (labelContainer !== null) {
                labelContainer.appendChild(historyDelete)
            }
        }
        return main
    }
}
